import toast, {ToastPosition} from "react-hot-toast"

export function triggerSuccessToast(message: string, position: ToastPosition = "bottom-center", hasMultipleToasters?: boolean) {
  {hasMultipleToasters && toast.dismiss()}
  toast.success(message, {duration: 5000, position})
}

export function triggerErrorToast(message: string, position: ToastPosition = "bottom-center") {
  toast.dismiss()
  toast.error(message, {duration: 5000, position})
}
